import merge from 'lodash/merge';
import {FEATURE_SELECTIONS} from '@mapsight/ui/src/js/config/constants/controllers';

import {VIEW_DESKTOP, VIEW_FULLSCREEN, VIEW_MAP_ONLY, VIEW_MOBILE} from '@mapsight/ui/src/js/config/constants/app';

import uiEmbed from '@mapsight/ui/embed';
import {siteConfig} from '@mapsight/ui/src/js/config';
import {getDictionary} from '@mapsight/ui/src/js/helpers/i18n';

// the file may not be generated when js-qa runs, so we ignore this:
// eslint-disable-next-line import/no-unresolved,import/extensions
import styleFunction from 'mapsight-vector-styles/vector-style.esm.js';

import updateDictionaryStade from '../stade/update-dictionary';
import updateDictionaryRatings from '../ratings/update-dictionary';

import {initialState as ratingsInitialState, RATINGS, RatingsController} from '../ratings/store/controller';
import {defaultStadeState, STADE, StadeController} from '../stade/store/controller';

import renderAwaitRouteAndFeaturesCreatePlugin from './plugins/render-route-to-store-and-await-features';

import baseMapsightConfig from './config';

import AdditionalContainerContent from './components/additional-container-content';
import AppWrapperStart from './components/app-wrapper-start';
import AppWrapperEnd from './components/app-wrapper-end';
import MapOverlayTopRight from './components/map-overlay-top-right';
import MapOverlayBottomLeft from './components/map-overlay-bottom-left';
import MapOverlayEnd from './components/map-overlay-end';
import MainPanelContainer from './components/main-panel-container';
import MapWrapper from './components/map-wrapper';

import {NavposSelectionController} from './store/navpos-selection-controller';
import {navPosition} from './routing/nav-pos';


// i18n
updateDictionaryStade(getDictionary());
updateDictionaryRatings(getDictionary());


// TODO hängt bei Stade zusätzlich von der URL ab, ob es die Kartenansicht ist oder nicht
function determineInitialClientRenderingView(magic, currentBreakpoints) {
	// NOTE: This will only be used for client side only rendering, otherwise initial view will be determined by server!
	const navPos = navPosition(magic, window.location.pathname, null);
	const isMobile = currentBreakpoints.indexOf('mobile') > -1;

	return navPos.map ?
		(isMobile ? VIEW_MAP_ONLY : VIEW_FULLSCREEN) :
		(isMobile ? VIEW_MOBILE : VIEW_DESKTOP);
}

// TODO Stade
siteConfig.topOffsetForView = function topOffsetForView(view) {
	// if (view === VIEW_MOBILE) {
	// 	return 50; // AreaSwitcher ist 42 hoch, der Menü-Knopf darüber 50. dh. ein Wert von 50 scrollt 8px oberhalb des Areaswitcher hin
	// }
	return 0;
};


const MAGIC_DEFAULT = {
	menu: {
		de: [
			{
				title: 'Hansestadt',
				url: 'https://www.stade-tourismus.de/de/hansestadt-stade/',
			},
			{
				title: 'Entdecken & Erleben',
				url: 'https://www.stade-tourismus.de/de/entdecken-und-erleben/',
			},
			{
				title: 'Datenschutz',
				url: 'https://www.stade-tourismus.de/de/service/rechtliches/datenschutz/',
				popup: true,
			},
			{
				title: 'Impressum',
				url: 'https://www.stade-tourismus.de/de/service/rechtliches/impressum/',
			},
		],
		en: [
			{
				title: 'Hansa town',
				url: 'https://www.stade-tourismus.de/de/hansestadt-stade/',
			},
			{
				title: 'Entdecken & Erleben',
				url: 'https://www.stade-tourismus.de/de/entdecken-und-erleben/',
			},
			{
				title: 'Data Protection Disclaimer',
				url: 'https://www.stade-tourismus.de/de/service/rechtliches/datenschutz/',
				popup: true,
			},
			{
				title: 'Imprint',
				url: 'https://www.stade-tourismus.de/de/service/rechtliches/impressum/',
			},
		]
	},
	apps: [
		// {
		// 	title: 'Kindertour',
		// 	url: '/de/tour/kinder',
		// 	uri: 'kinder-de',
		// 	lang: 'de',
		// 	description: 'Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. ',
		// 	leadImage: {
		// 		url: "http:\/\/p-stade.localhost\/backend\/media\/pages\/wall\/spielplatz\/6a98c3b5a2-1629126736\/2016_hn_160827_zytanien_festival.50_gallery_detail.jpg",
		// 		width: 918,
		// 		height: 612,
		// 		caption: "",
		// 		alt: "",
		// 		resized: [
		// 			{
		// 				url: "http:\/\/p-stade.localhost\/backend\/media\/pages\/wall\/spielplatz\/6a98c3b5a2-1629126736\/2016-hn-160827-zytanien-festival-50-gallery-detail-512x-q80.jpg",
		// 				width: 512,
		// 				height: 341
		// 			},
		// 			{
		// 				url: "http:\/\/p-stade.localhost\/backend\/media\/pages\/wall\/spielplatz\/6a98c3b5a2-1629126736\/2016-hn-160827-zytanien-festival-50-gallery-detail-1024x-q80.jpg",
		// 				width: 918,
		// 				height: 612
		// 			}
		// 		]
		// 	}
		// },
		// {
		// 	title: 'Tour Wallanlagen',
		// 	url: '/de/tour/wallanlagen',
		// 	uri: 'wall-de',
		// 	lang: 'de',
		// 	description: 'Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. ',
		// 	leadImage: {
		// 		url: "http:\/\/p-stade.localhost\/backend\/media\/pages\/wall\/spielplatz\/6a98c3b5a2-1629126736\/2016_hn_160827_zytanien_festival.50_gallery_detail.jpg",
		// 		width: 918,
		// 		height: 612,
		// 		caption: "",
		// 		alt: "",
		// 		resized: [
		// 			{
		// 				url: "http:\/\/p-stade.localhost\/backend\/media\/pages\/wall\/spielplatz\/6a98c3b5a2-1629126736\/2016-hn-160827-zytanien-festival-50-gallery-detail-512x-q80.jpg",
		// 				width: 512,
		// 				height: 341
		// 			},
		// 			{
		// 				url: "http:\/\/p-stade.localhost\/backend\/media\/pages\/wall\/spielplatz\/6a98c3b5a2-1629126736\/2016-hn-160827-zytanien-festival-50-gallery-detail-1024x-q80.jpg",
		// 				width: 918,
		// 				height: 612
		// 			}
		// 		]
		// 	}
		// },
		// {
		// 	title: 'Tour Ramparts',
		// 	url: '/en/tour/ramparts',
		// 	uri: 'wall-en',
		// 	lang: 'en',
		// 	description: 'Nam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.',
		// 	leadImage: {
		// 		url: "http:\/\/p-stade.localhost\/backend\/media\/pages\/wall\/spielplatz\/6a98c3b5a2-1629126736\/2016_hn_160827_zytanien_festival.50_gallery_detail.jpg",
		// 		width: 918,
		// 		height: 612,
		// 		caption: "",
		// 		alt: "",
		// 		resized: [
		// 			{
		// 				url: "http:\/\/p-stade.localhost\/backend\/media\/pages\/wall\/spielplatz\/6a98c3b5a2-1629126736\/2016-hn-160827-zytanien-festival-50-gallery-detail-512x-q80.jpg",
		// 				width: 512,
		// 				height: 341
		// 			},
		// 			{
		// 				url: "http:\/\/p-stade.localhost\/backend\/media\/pages\/wall\/spielplatz\/6a98c3b5a2-1629126736\/2016-hn-160827-zytanien-festival-50-gallery-detail-1024x-q80.jpg",
		// 				width: 918,
		// 				height: 612
		// 			}
		// 		]
		// 	}
		// },
	]
};

// used to define defaults specific to projects
// STATE_DEFAULT.app wird überschrieben von mapsights eigenen defaultUiState, stattdessen UI_STATE_DEFAULT nutzen
const STATE_DEFAULT = {
	featureSources: {},
	list: {
		visible: false,
	},
	map: {
		visible: true,
	},
};
const UI_STATE_DEFAULT = {
	//viewDefaultDesktop: VIEW_FULLSCREEN, // NOTE(PG): Seems not to be used anywhere
	listSorting: '',
	embeddedMap: false, // map is embedded which switch some behaviours which would be annoying
	searchInMap: false,  // enable address search in map overlay
	list: {
		visible: false, // Stade has it's own list (which is based on mapsight's one and will thereof adhere to the following settings if applicable
		// selectionBehavior: {mobile: 'selectOnly'}, TODO set to select only for all views
		scrollToItemOnPreselect: true,
		integratedList: false, // if true list will be left of the map on desktops even when not in fullscreen mode
		detailsInList: false, // if true details will always be shown in list even if not on mobile
		showSelectedOnly: false, // don't show list entries, only show the selected one (need some other kind of communication, cyclingControl or Icons on the map)
		deselectOnClick: false, // deselect on click to selected list item
		cyclingControl: false, // show a control to select next or previous list entry -- unusable for Stade, we need our own
		sortControl: false, // show sort control icon
		filterControl: false, // show filter box
		stickyHeader: false, // disable sticky list header
		renderAs: 'ul',
		renderItemAs: 'li',
		renderGroupAs: 'h2', // TODO set renderGroupAs to useful value
	},
	pageTitle: {
		show: false,
	},
	layerSwitcher: {
		show: {
			internal: false,
			external: false,
		},
		internal: {
			grouped: true,
		},
	},
	// tagSwitcher: {
	// 	toggleableGroups: true,
	// 	sortTags: true,
	// },
};

/**
 * @param {import("./types").Magic} origMagic
 * @returns {import("./types").Magic}
 */
export function processMagic(origMagic) {
	return Object.assign({},
		MAGIC_DEFAULT,
		origMagic);
}

// INFO: kept magic from vmznds, as it may be useful some time in the future
/**
 * @param {{magic: object, uri: string, state: object}} options
 */
export default function embed({magic, uri: locPathName, state}) {
	const embedOptions = {
		imagesUrl: navPosition(magic, locPathName)?.app?.url + '/img/',
		plugins: typeof window !== 'undefined' ? [
			['corePreset', null],
		] : [
			// for server side rendering we want to execute routeToStore first and then wait for the lists feature sources as well as feature details to be loaded
			['route', renderAwaitRouteAndFeaturesCreatePlugin({magic, locPathName})],
			['corePreset', null],
		],
		controllers: {
			[FEATURE_SELECTIONS]: new NavposSelectionController(FEATURE_SELECTIONS, magic),
			// add second ListController

			[STADE]: new StadeController(STADE, magic),
			[RATINGS]: new RatingsController(RATINGS),
		},
		// hook({store, controllers}) {
		// 	if (process.env.NN_JS_LOG_LEVEL === 'verbose') {
		// 		console.warn('debug: hook(controllers):', controllers);
		// 	}
		//
		// 	let detailsFeature = undefined;
		//
		// 	// let listQuery = undefined;
		//
		// 	store.subscribe(() => {
		// 		const storeState = store.getState();
		//
		// 		// aktuell keine Tags bei Stade → auskommentiert
		// 		// // clear tag selection when `listQuery` changes
		// 		// const prevListQuery = listQuery;
		// 		// listQuery = listQuerySelector(storeState);
		// 		// if (listQuery !== prevListQuery) {
		// 		// 	store.dispatch(hideTagAndTagGroup());
		// 		// }
		//
		// 		// wenn es eine _gültige_ selection gibt (z.B. über die URL bei topic.deepLink===true)
		// 		// dann darf der view nicht VIEW_MAP_ONLY sein (genau anders herum als bei VMZNDS)#
		// 		// → der view wird jetzt direkt in der route-to-store gesetzt
		// 		// detailsFeature = storeState[FEATURE_SELECTIONS] && detailsFeatureSelector(storeState); // this is called very early so it need an addtional test to protect the selector
		// 		// if (
		// 		// 	detailsFeature
		// 		// 	&& viewSelector(storeState) === VIEW_MAP_ONLY
		// 		// ) {
		// 		// 	store.dispatch(setView(VIEW_MOBILE));
		// 		// }
		// 	});
		// },
		/** @type {import("react").Context<import("@mapsight/ui/src/js/components/contexts.js").Components>} */
		components: {
			AdditionalContainerContent, // RouteToStore
			AppWrapperStart, // immer vorhandener Header + Details des POI auf Detail-Seiten
			AppWrapperEnd, // Seitenfuß, ggf. Widget unterhalb des Kartenwidgets
			MainPanelStart: _ => null,
			MainPanelContainer,
			// MapOverlayStart: _ => null, // Heading in Fullscreen
			MapOverlayEnd,
			MapOverlayTopLeft: _ => null, // disable search and region-selector
			MapOverlayTopRight,
			MapOverlayBottomLeft,
			MapOverlayBottomRight: _ => null, // disable Fullscreen-Icon
			FeatureDetailsContent: _ => null, // we display the feature details elsewhere
			MapWrapper: MapWrapper,
			// TODO TooltipContent,
		},
		// ...embedOptions,  // removed as not allowed for pages with VMZNDS2020
		defaultPluginsOptions: {
			views: {
				determineInitialView: determineInitialClientRenderingView.bind(null, magic)
			},
			userGeolocation: {
				storeInLocalStorage: true,
			},
			piwikTrackFullscreenToggleEvent: {
				disabled: true
			},
			featurePreselectDeepLink: {
				featureSelection: 'Leave my store alone!', // HOTFIX for unwanted default plugin
			}
		},
		renderBreakpoints: {
			// TODO Stade: Keep in sync with css!
			// taken from Stade's website
			mobile: [0, 1024],
			desktop: [1025, -1],
		},
	};

	const mergedState = merge(
		{},
		STATE_DEFAULT,
		baseMapsightConfig(magic, locPathName),
		{
			[STADE]: defaultStadeState,
			[RATINGS]: ratingsInitialState(),
		}
	);

	return uiEmbed(
		styleFunction,
		mergedState,
		{},
		Object.assign({}, UI_STATE_DEFAULT, state ? state.app : undefined),
		embedOptions,
	);
}
